import { useMemo } from "react";
import {
  addTakerFee,
  formatDecimals,
  toHighDenom,
  toLowDenom,
} from "../currencies";
import useCryptoInUSD from "./useCryptoInUSD";
import usePaymentCurrency from "./usePaymentCurrency";

interface TakerPrice {
  price?: string;
  paymentErc20TokenAddress?: string;
  takerFee?: number;
}

export const getTotalPrice = (
  price: string | undefined,
  paymentMethod: any,
  takerFee: number | undefined,
) => {
  if (!price) return;

  const rawTotalPrice = addTakerFee(price!, takerFee);
  const totalPrice = toHighDenom(rawTotalPrice, paymentMethod?.decimals);
  const rounded = formatDecimals(totalPrice, 4, false);
  return {
    raw: rawTotalPrice?.toString(),
    rawRounded: toLowDenom(rounded, paymentMethod.decimals),
    rounded,
  };
};

export default function useTotalTakerPrice({
  price,
  paymentErc20TokenAddress,
  takerFee,
}: TakerPrice) {
  const paymentMethod = usePaymentCurrency(paymentErc20TokenAddress);

  const totalPrice = useMemo(
    () => getTotalPrice(price, paymentMethod, takerFee),
    [price, paymentMethod, takerFee],
  );
  const { cryptoInUSD } = useCryptoInUSD(
    totalPrice?.rounded,
    paymentMethod?.id,
  );

  return {
    totalPrice,
    totalPriceInUSD: cryptoInUSD,
    getTotalPrice,
  };
}
